import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Menubar } from '@bayclubs/horizon';
import { MenubarFacade } from './menubar.facade';

@Component({
    selector: 'app-menubar',
    imports: [Menubar],
    templateUrl: './menubar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MenubarFacade]
})
export class MenubarComponent {
    private readonly facade = inject(MenubarFacade);

    items = this.facade.items;
    userName = this.facade.userName;

    handleLogout(): void {
        this.facade.logout();
    }
}
